// @flow

import * as React from "react";
import _ from "lodash";
import ComponentBuilder from "../components/organisms/ComponentBuilder";
import HeroCampaign from "../components/organisms/HeroCampaign";

import useNoNav from "../hooks/useNoNav";

type PropsType = {
    page: any,
};

const Campaign = (props: PropsType): React.Node => {
    const { page } = props;
    const components =
        _.get(page, "acf.component_builder.component_builder") || [];

    // Hero Content
    const hero = page.acf;

    useNoNav();

    return (
        <React.Fragment>
            <HeroCampaign {...hero} heading={page.post_title} />
            <div className="page-campaign">
                {hero.description && (
                    <div className="container-fluid">
                        <div className="page-campaign__row row">
                            <div className="col-xs-12 col-md-offset-1 col-lg-offset-2 col-md-10 col-lg-8">
                                <p className="hero-campaign__description">
                                    {hero.description}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <ComponentBuilder
                    components={components}
                    isContentPageComponent
                />
            </div>
        </React.Fragment>
    );
};

Campaign.defaultProps = {
    heroTitleSize: "heading-1",
    showRelated: true,
};

export default Campaign;
